import { EMOJI_CATEGORY } from '~/components/UiKit/emoji-selector/EmojiSelector.constant';
import { flatten, flow, map, memoize } from 'lodash';
import { values } from 'ramda';

export const getEmojiList = memoize(() => {
  return flow(values, flatten, (emojiList) => map(emojiList, (value) => ({ id: value, value })))(EMOJI_CATEGORY) as {
    id: string;
    value: string;
  }[];
});
